import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/PricingPage.css';

function PricingPage() {
  const navigate = useNavigate();
  const [billingCycle, setBillingCycle] = useState('monthly'); // 'monthly' | 'yearly'

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const handleSelectPlan = (planKey) => {
    navigate(`/register/physiotherapist?membership=${planKey}&billing=${billingCycle}`, {
      state: { membership: planKey, billingCycle },
    });
  };

  return (
    <div className="pm-pricing-page">
      {/* Dynamic Background Glows */}
      <div className="pm-pricing-ambient-mesh">
        <div className="pm-pricing-orb pm-pricing-orb-1"></div>
        <div className="pm-pricing-orb pm-pricing-orb-2"></div>
      </div>

      {/* =========================================================
          COMPACT & MINIMAL HERO SECTION
          ========================================================= */}
      <header className="pm-pricing-hero">
        <div className="pm-pricing-hero-inner">
          <h1 className="pm-pricing-main-title">
            <span className="pm-pricing-gradient">Plans</span>
          </h1>

          <p className="pm-pricing-subtitle">
            Keep 100% of your earnings. <br />
            Select the plan that fits your clinical practice.
          </p>

          {/* Billing Switcher Toggle */}
          <div className="pm-billing-switcher-wrap" role="group" aria-label="Billing cycle selector">
            <button
              id="pm-toggle-monthly"
              type="button"
              className={`pm-billing-toggle-btn ${billingCycle === 'monthly' ? 'active' : ''}`}
              onClick={() => setBillingCycle('monthly')}
            >
              <span>Monthly</span>
            </button>
            <button
              id="pm-toggle-yearly"
              type="button"
              className={`pm-billing-toggle-btn ${billingCycle === 'yearly' ? 'active' : ''}`}
              onClick={() => setBillingCycle('yearly')}
            >
              <span>Yearly</span>
              <span className="pm-save-chip">Save 17%</span>
            </button>
          </div>
        </div>
      </header>

      {/* =========================================================
          PRICING PLAN CARDS (2-Column Modern Grid)
          ========================================================= */}
      <section className="pm-pricing-cards-section">
        <div className="pm-pricing-cards-grid">
          {/* FREE PLAN */}
          <div className="pm-plan-card is-free">
            <div>
              <div className="pm-plan-header">
                <div className="pm-plan-icon-wrap">🌱</div>
                <h2 className="pm-plan-title">Free Listing</h2>
                <p className="pm-plan-tagline">Basic Practitioner Profile</p>

                {/* Free Tier Indicator for Card Alignment */}
                <div className="pm-plan-option-pills is-free-pill" aria-hidden="true">
                  <div className="pm-plan-option-pill is-active">
                    <span>🌱 Standard Free Tier</span>
                  </div>
                </div>

                <div className="pm-plan-price-wrap">
                  <div className="pm-plan-price-box">
                    <div className="pm-plan-price-row">
                      <span className="pm-plan-price">₹0</span>
                      <span className="pm-plan-duration-inline">/ forever free</span>
                    </div>
                    <span className="pm-plan-annual-sub" style={{ color: '#6b7280' }}>
                      No credit card required
                    </span>
                  </div>
                </div>
              </div>

              <ul className="pm-plan-features-list">
                <li className="pm-plan-feature-item">
                  <span className="pm-plan-check-icon"><i className="fas fa-check"></i></span>
                  <span><strong>Calendar Sync:</strong> Included (Yes)</span>
                </li>
                <li className="pm-plan-feature-item">
                  <span className="pm-plan-check-icon"><i className="fas fa-check"></i></span>
                  <span><strong>Automated Google Meet link:</strong> Included</span>
                </li>
                <li className="pm-plan-feature-item">
                  <span className="pm-plan-check-icon"><i className="fas fa-check"></i></span>
                  <span><strong>Sell Digital Products/ Content:</strong> Included</span>
                </li>
                <li className="pm-plan-feature-item">
                  <span className="pm-plan-check-icon" style={{ background: '#fef3c7', color: '#b45309' }}>
                    <i className="fas fa-info"></i>
                  </span>
                  <span><strong>Can add images:</strong> Only 1 photo limit</span>
                </li>
                <li className="pm-plan-feature-item">
                  <span className="pm-plan-check-icon" style={{ background: '#fef3c7', color: '#b45309' }}>
                    <i className="fas fa-info"></i>
                  </span>
                  <span><strong>Workshop listings:</strong> Paid workshop listing</span>
                </li>
                {/* <li className="pm-plan-feature-item" style={{ opacity: 0.65 }}>
                  <span className="pm-plan-check-icon" style={{ background: '#f1f5f9', color: '#94a3b8' }}>
                    <i className="fas fa-times"></i>
                  </span>
                  <span>Session Notes Template &amp; Worksheets: <strong>No</strong></span>
                </li>
                <li className="pm-plan-feature-item" style={{ opacity: 0.65 }}>
                  <span className="pm-plan-check-icon" style={{ background: '#f1f5f9', color: '#94a3b8' }}>
                    <i className="fas fa-times"></i>
                  </span>
                  <span>Blogging &amp; Introductory video: <strong>No</strong></span>
                </li>
                <li className="pm-plan-feature-item" style={{ opacity: 0.65 }}>
                  <span className="pm-plan-check-icon" style={{ background: '#f1f5f9', color: '#94a3b8' }}>
                    <i className="fas fa-times"></i>
                  </span>
                  <span>Enhanced visibility &amp; Pro verified badge: <strong>No</strong></span>
                </li>
                <li className="pm-plan-feature-item" style={{ opacity: 0.65 }}>
                  <span className="pm-plan-check-icon" style={{ background: '#f1f5f9', color: '#94a3b8' }}>
                    <i className="fas fa-times"></i>
                  </span>
                  <span>Chat/sharing wall reply: <strong>No Access</strong></span>
                </li>
                <li className="pm-plan-feature-item" style={{ opacity: 0.65 }}>
                  <span className="pm-plan-check-icon" style={{ background: '#f1f5f9', color: '#94a3b8' }}>
                    <i className="fas fa-times"></i>
                  </span>
                  <span>Automatic session reminders &amp; Bundles: <strong>No</strong></span>
                </li> */}
              </ul>
            </div>

            <button
              type="button"
              className="pm-plan-btn"
              onClick={() => handleSelectPlan('free')}
            >
              <span>Start Free Listing</span>
              <i className="fas fa-arrow-right"></i>
            </button>
          </div>

          {/* PRO PLAN (FEATURED) */}
          <div className="pm-plan-card is-pro">
            <span className="pm-pro-badge-top">
              <i className="fas fa-sparkles me-1"></i> RECOMMENDED FOR PRACTITIONERS
            </span>

            <div>
              <div className="pm-plan-header">
                <div className="pm-plan-icon-wrap">💎</div>
                <h2 className="pm-plan-title">Pro Provider</h2>
                <p className="pm-plan-tagline" style={{ color: '#7c3aed', fontWeight: 700 }}>
                  All-in-One Clinical Suite
                </p>

                {/* In-Card Plan Option Selector */}
                <div className="pm-plan-option-pills" role="tablist" aria-label="Pro plan billing cycle">
                  <button
                    id="pm-card-toggle-monthly"
                    type="button"
                    className={`pm-plan-option-pill ${billingCycle === 'monthly' ? 'is-active' : ''}`}
                    onClick={() => setBillingCycle('monthly')}
                  >
                    <span>Monthly Plan</span>
                  </button>
                  <button
                    id="pm-card-toggle-yearly"
                    type="button"
                    className={`pm-plan-option-pill ${billingCycle === 'yearly' ? 'is-active' : ''}`}
                    onClick={() => setBillingCycle('yearly')}
                  >
                    <span>Yearly Plan</span>
                    <span className="pm-pill-badge">Save 17%</span>
                  </button>
                </div>

                <div className="pm-plan-price-wrap">
                  <div className="pm-plan-price-box">
                    <div className="pm-plan-price-row">
                      {billingCycle === 'monthly' ? (
                        <>
                          <span className="pm-plan-cut-price" title="Original monthly price">₹1,999</span>
                          <span className="pm-plan-price">₹999</span>
                          <span className="pm-plan-duration-inline">/month</span>
                        </>
                      ) : (
                        <>
                          <span className="pm-plan-cut-price" title="Original yearly price">₹12,000</span>
                          <span className="pm-plan-price">₹9,999</span>
                          <span className="pm-plan-duration-inline">/year</span>
                          <span className="pm-plan-per-month-chip">₹833/mo</span>
                        </>
                      )}
                    </div>
                    <span className="pm-plan-annual-sub" style={{ color: billingCycle === 'monthly' ? '#6b7280' : '#16a34a' }}>
                      {billingCycle === 'monthly' ? 'Billed monthly • Cancel anytime' : 'Billed annually • Save ₹2,001 (2 Months Free)'}
                    </span>
                  </div>
                </div>
              </div>

              <ul className="pm-plan-features-list">
                <li className="pm-plan-feature-item">
                  <span className="pm-plan-check-icon"><i className="fas fa-check"></i></span>
                  <span><strong>Calendar Sync</strong> &amp; <strong>Automated Google Meet link</strong></span>
                </li>
                <li className="pm-plan-feature-item">
                  <span className="pm-plan-check-icon"><i className="fas fa-check"></i></span>
                  <span><strong>Session Notes Template</strong> (SOAP) &amp; <strong>Worksheets</strong></span>
                </li>
                <li className="pm-plan-feature-item">
                  <span className="pm-plan-check-icon"><i className="fas fa-check"></i></span>
                  <span><strong>Blogging:</strong> Publish articles &amp; clinical insights</span>
                </li>
                <li className="pm-plan-feature-item">
                  <span className="pm-plan-check-icon"><i className="fas fa-check"></i></span>
                  <span><strong>Can add images:</strong> Multiple photos &amp; clinic gallery</span>
                </li>
                <li className="pm-plan-feature-item">
                  <span className="pm-plan-check-icon"><i className="fas fa-check"></i></span>
                  <span><strong>Can add an introductory video</strong> on profile</span>
                </li>
                <li className="pm-plan-feature-item">
                  <span className="pm-plan-check-icon"><i className="fas fa-check"></i></span>
                  <span><strong>Enhanced visibility</strong> &amp; <strong>Pro verified Badge visible</strong></span>
                </li>
                <li className="pm-plan-feature-item">
                  <span className="pm-plan-check-icon"><i className="fas fa-check"></i></span>
                  <span><strong>Can reply on chat/sharing wall</strong> from main account</span>
                </li>
                <li className="pm-plan-feature-item">
                  <span className="pm-plan-check-icon"><i className="fas fa-check"></i></span>
                  <span><strong>Sell Digital Products/ Content</strong></span>
                </li>
                <li className="pm-plan-feature-item">
                  <span className="pm-plan-check-icon"><i className="fas fa-check"></i></span>
                  <span><strong>1 Workshop listing free/ Month</strong></span>
                </li>
                <li className="pm-plan-feature-item">
                  <span className="pm-plan-check-icon"><i className="fas fa-check"></i></span>
                  <span><strong>Automatic session reminders</strong> (WhatsApp &amp; Email)</span>
                </li>
                <li className="pm-plan-feature-item">
                  <span className="pm-plan-check-icon"><i className="fas fa-check"></i></span>
                  <span><strong>Session Bundles:</strong> Offer multi-session discount packages</span>
                </li>
              </ul>
            </div>

            <button
              type="button"
              className="pm-plan-btn"
              onClick={() => handleSelectPlan('pro')}
            >
              <span>{billingCycle === 'monthly' ? 'Get Started with Pro Monthly' : 'Get Started with Pro Yearly'}</span>
              <i className="fas fa-arrow-right"></i>
            </button>
          </div>
        </div>
      </section>

      {/* =========================================================
          DETAILED COMPARISON TABLE (PRO vs FREE AS PER SPEC)
          ========================================================= */}
      <section className="pm-matrix-section">
        <div className="pm-matrix-container">
          <div className="pm-matrix-header-center">
            <h2 className="pm-matrix-title">Compare Plan Features</h2>
            <p className="pm-matrix-subtitle">
              Detailed breakdown of features included in Pro vs Free plans
            </p>
          </div>

          <div className="pm-table-wrapper">
            <table className="pm-compare-table">
              <thead>
                <tr>
                  <th style={{ width: '44%' }}>Features</th>
                  <th className="col-pro" style={{ width: '28%', textAlign: 'center' }}>
                    <div style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                      <span style={{ fontSize: '15px', fontWeight: 900 }}>PRO</span>
                      <span style={{ fontSize: '11px', background: '#7c4bb9', color: '#fff', padding: '2px 8px', borderRadius: '10px', fontWeight: 700 }}>
                        {billingCycle === 'monthly' ? '₹999/mo' : '₹9,999/yr'}
                      </span>
                    </div>
                  </th>
                  <th className="col-free" style={{ width: '28%', textAlign: 'center' }}>
                    <div style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                      <span style={{ fontSize: '15px', fontWeight: 900, color: '#334155' }}>FREE</span>
                      <span style={{ fontSize: '11px', background: '#e2e8f0', color: '#475569', padding: '2px 8px', borderRadius: '10px', fontWeight: 700 }}>
                        ₹0
                      </span>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {/* 1. Calendar Sync */}
                <tr className="pm-table-row">
                  <td>
                    <div className="pm-feature-name">Calendar Sync</div>
                    <div className="pm-feature-desc">Two-way Google Calendar synchronization</div>
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    <span className="pm-status-badge available">
                      <i className="fas fa-check"></i> Yes
                    </span>
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    <span className="pm-status-badge available">
                      <i className="fas fa-check"></i> Yes
                    </span>
                  </td>
                </tr>

                {/* 2. Session Notes Template */}
                <tr className="pm-table-row">
                  <td>
                    <div className="pm-feature-name">Session Notes Template</div>
                    <div className="pm-feature-desc">SOAP clinical documentation &amp; therapy notes</div>
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    <span className="pm-status-badge available">
                      <i className="fas fa-check"></i> Yes
                    </span>
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    <span className="pm-status-badge unavailable">
                      <i className="fas fa-times"></i> No
                    </span>
                  </td>
                </tr>

                {/* 3. Worksheets */}
                <tr className="pm-table-row">
                  <td>
                    <div className="pm-feature-name">Worksheets</div>
                    <div className="pm-feature-desc">Interactive clinical therapy worksheets &amp; exercises</div>
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    <span className="pm-status-badge available">
                      <i className="fas fa-check"></i> Yes
                    </span>
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    <span className="pm-status-badge unavailable">
                      <i className="fas fa-times"></i> No
                    </span>
                  </td>
                </tr>

                {/* 4. Blogging */}
                <tr className="pm-table-row">
                  <td>
                    <div className="pm-feature-name">Blogging</div>
                    <div className="pm-feature-desc">Publish articles &amp; thought leadership on PsychMitra</div>
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    <span className="pm-status-badge available">
                      <i className="fas fa-check"></i> Yes
                    </span>
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    <span className="pm-status-badge unavailable">
                      <i className="fas fa-times"></i> No
                    </span>
                  </td>
                </tr>

                {/* 5. Can add images */}
                <tr className="pm-table-row">
                  <td>
                    <div className="pm-feature-name">Can add images</div>
                    <div className="pm-feature-desc">Profile, clinic &amp; certificates photo gallery</div>
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    <span className="pm-status-badge available">
                      <i className="fas fa-check"></i> Multiple / Unlimited
                    </span>
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    <span className="pm-status-badge warning">
                      Only 1
                    </span>
                  </td>
                </tr>

                {/* 6. Can add an introductory video */}
                <tr className="pm-table-row">
                  <td>
                    <div className="pm-feature-name">Can add an introductory video</div>
                    <div className="pm-feature-desc">Personal video introduction to build patient trust</div>
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    <span className="pm-status-badge available">
                      <i className="fas fa-check"></i> Yes
                    </span>
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    <span className="pm-status-badge unavailable">
                      <i className="fas fa-times"></i> No
                    </span>
                  </td>
                </tr>

                {/* 7. enhanced visibility */}
                <tr className="pm-table-row">
                  <td>
                    <div className="pm-feature-name">enhanced visibility</div>
                    <div className="pm-feature-desc">Boosted placement in practitioner search &amp; filters</div>
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    <span className="pm-status-badge available">
                      <i className="fas fa-check"></i> Yes
                    </span>
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    <span className="pm-status-badge unavailable">
                      <i className="fas fa-times"></i> No
                    </span>
                  </td>
                </tr>

                {/* 8. Pro verified Badge visible */}
                <tr className="pm-table-row">
                  <td>
                    <div className="pm-feature-name">Pro verified Badge visible</div>
                    <div className="pm-feature-desc">Verified practitioner Pro badge on profile &amp; directory</div>
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    <span className="pm-status-badge available">
                      <i className="fas fa-check"></i> Yes
                    </span>
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    <span className="pm-status-badge unavailable">
                      <i className="fas fa-times"></i> No
                    </span>
                  </td>
                </tr>

                {/* 9. Can reply on chat/sharing wall from main acc */}
                <tr className="pm-table-row">
                  <td>
                    <div className="pm-feature-name">Can reply on chat/sharing wall from main acc</div>
                    <div className="pm-feature-desc">Direct practitioner community answers from practice handle</div>
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    <span className="pm-status-badge available">
                      <i className="fas fa-check"></i> Yes (Full Access)
                    </span>
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    <span className="pm-status-badge unavailable">
                      <i className="fas fa-times"></i> No Access
                    </span>
                  </td>
                </tr>

                {/* 10. Sell Digital Products/ Content */}
                <tr className="pm-table-row">
                  <td>
                    <div className="pm-feature-name">Sell Digital Products/ Content</div>
                    <div className="pm-feature-desc">Sell guides, audio sessions, worksheets &amp; keep earnings</div>
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    <span className="pm-status-badge available">
                      <i className="fas fa-check"></i> Sell Digital Products/Content
                    </span>
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    <span className="pm-status-badge available">
                      <i className="fas fa-check"></i> Sell Digital Products/Content
                    </span>
                  </td>
                </tr>

                {/* 11. Automated Google Meet link */}
                <tr className="pm-table-row">
                  <td>
                    <div className="pm-feature-name">Automated Google Meet link</div>
                    <div className="pm-feature-desc">Auto-generated telehealth consultation video link</div>
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    <span className="pm-status-badge available">
                      <i className="fas fa-check"></i> Automated Google Meet link
                    </span>
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    <span className="pm-status-badge available">
                      <i className="fas fa-check"></i> Automated Google Meet Link
                    </span>
                  </td>
                </tr>

                {/* 12. 1 Workshop listing free/ Month and then Paid */}
                <tr className="pm-table-row">
                  <td>
                    <div className="pm-feature-name">1 Workshop listing free/ Month</div>
                    <div className="pm-feature-desc">Promote webinars &amp; workshops to platform clients</div>
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    <span className="pm-status-badge available">
                      <i className="fas fa-check"></i> 1 Workshop listing free/ Month
                    </span>
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    <span className="pm-status-badge warning">
                      Paid Workshop listing
                    </span>
                  </td>
                </tr>

                {/* 13. Automatic session reminders */}
                <tr className="pm-table-row">
                  <td>
                    <div className="pm-feature-name">Automatic session reminders</div>
                    <div className="pm-feature-desc">Automated WhatsApp &amp; Email alerts to reduce no-shows</div>
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    <span className="pm-status-badge available">
                      <i className="fas fa-check"></i> Automatic session reminders
                    </span>
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    <span className="pm-status-badge unavailable">
                      <i className="fas fa-times"></i> Not available
                    </span>
                  </td>
                </tr>

                {/* 14. Session Bundles */}
                <tr className="pm-table-row">
                  <td>
                    <div className="pm-feature-name">Session Bundles</div>
                    <div className="pm-feature-desc">Offer bundled multi-session discount packages to patients</div>
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    <span className="pm-status-badge available">
                      <i className="fas fa-check"></i> Yes
                    </span>
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    <span className="pm-status-badge unavailable">
                      <i className="fas fa-times"></i> No
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </div>
  );
}

export default PricingPage;

